// 検査箇所のコピー&ペーストはラベルマスタ（ページ）を跨いで行う可能性があるため、sessionStorageで状態を持つ

const STORAGE_KEY = 'copyLabelAreas.sourceLabelId'

export const getSourceLabelId = (): string | undefined => {
  return sessionStorage.getItem(STORAGE_KEY) ?? undefined
}

export const setSourceLabelId = (id: string): void => {
  sessionStorage.setItem(STORAGE_KEY, id)
}
